import React, { useEffect, useState } from 'react';

import { EYE_WEARS } from '../../helpers/renderOpenGraph/metaData';

import './ProductHeader.scss';

const ProductHeader = () => {
  const [currentHeader, setCurrentHeader] = useState({});

  const detectPath = (currentPath, targetPath) =>
    currentPath?.includes(`/sg/en${targetPath}`) || currentPath?.includes(targetPath);

  useEffect(() => {
    const currentPath = window.location.pathname;
    const matchingHeader = EYE_WEARS?.find(header => detectPath(currentPath, header.targetPath));

    if (matchingHeader) {
      setCurrentHeader(matchingHeader);
    } else {
      setCurrentHeader({});
    }
  }, []);

  useEffect(() => {
    if (Object.keys(currentHeader).length) {
      const separatorElements = document.getElementsByClassName('breadcrumb-separator');

      Array.from(separatorElements).forEach(element => {
        if (element.textContent === '/') {
          element.textContent = '>';
        }
      });
    }
  }, [currentHeader]);

  return Object.keys(currentHeader).length > 0 ? (
    <div className="product-header">
      <h1 className="product-header__name">{currentHeader.title}</h1>
      <p className="product-header__description">{currentHeader.description}</p>
    </div>
  ) : null;
};

export default ProductHeader;
